import type { DatePickerTargetWrapTypes } from '@libs/ui/ds/lib/components/dates/DatePickerInput/specialized/DatePickerInput/subs/DatePickerCustomTargetWrap.types'
import type { ComponentType, FC, ReactElement } from 'react'

import { DatePickerTargetInput } from './targets/DatePickerTargetInput'

type CustomTargetComponent = ComponentType<DatePickerTargetWrapTypes>

type CustomTargetFunction = (props: DatePickerTargetWrapTypes) => ReactElement

export const DatePickerCustomTargetWrap: FC<
  DatePickerTargetWrapTypes
> = props => {
  const { customTarget } = props

  /**
   * Default target component if no custom target is provided
   */
  if (!customTarget) {
    return <DatePickerTargetInput {...props} />
  }

  /**
   * Custom target function
   */
  if (typeof customTarget === 'function') {
    return (customTarget as CustomTargetFunction)(props)
  }

  /**
   * Instanciate custom preset target component
   */
  const Component = customTarget as CustomTargetComponent
  return <Component {...props} />
}
